module.exports = __webpack_public_path__ + "static/media/12UNCTAD8.213f3cc1.jpg";